
<div
  v-if="popupState"
  id="popup-component"
  ref="modal"
  class="modal-mask fixed z-[9998] top-0 left-0 w-full h-full table"
  :class="!sidebarVariant && 'bg-[rgba(0,0,0,0.5)]'"
>
  <div :class="!sidebarVariant ? 'modal-wrapper table-cell align-middle' : 'h-full'" @mousedown.prevent="closePopup">
    <div
      role="dialog"
      aria-modal="true"
      :aria-label="popupHeader"
      :class="`modal-content bg-foreground box-shadow-static-lg px-16 pb-16 w-full rounded-t-xl bottom-0 fixed sm:static sm:m-auto sm:rounded-xl overflow-auto ${sidebarClass} ${widthClass} ${customClasses}`"
      @mousedown.stop
    >
      <div class="bg-foreground sticky top-0 z-[1]">
        <div class="flex py-16">
          <h2 :class="`${headerClass} text-grey-header`">{{ popupHeader }}</h2>
          <button class="primary-focus ml-auto" aria-label="Close" @click="closePopup">
            <CloseIcon color="#4B4C52" aria-hidden="true" />
          </button>
        </div>
        <hr v-if="hasHeaderDivider" class="border-grey-divider-subdued -mx-16" />
      </div>
      <slot />
    </div>
  </div>
</div>
